import { z } from 'zod';
import { FindingSeveritySchema } from '@terra/shared-schemas-orchestrator';
import {
  BulkCustomerFindingStatusSchema,
  FindingListEnrichedDtoSchema,
  FindingsListQuerySchema,
} from './findings.schemas';

const FindingsSelectionQuerySchema = z.object({
  query: FindingsListQuerySchema,
});

export const FindingsListSelectionSchema = z.union([
  FindingsSelectionQuerySchema.extend({
    allSelected: z.literal(true),
  }),
  z.object({
    selectedIds: z.array(z.string()).min(1),
    includeUnpublished: z.boolean().optional(),
  }),
  FindingsSelectionQuerySchema.extend({
    excludedIds: z.array(z.string()).min(1),
  }),
]);

export const UpdateFindingsByListSelectionSchema = z.intersection(
  FindingsListSelectionSchema,
  z.object({
    update: z.object({
      status: BulkCustomerFindingStatusSchema.optional(),
      assignedTo: z.string().optional(),
      severity: FindingSeveritySchema.optional(),
      isPublished: z.boolean().optional(),
    }),
  }),
);

export const ResolveFindingsListSelectionResponseSchema = z.object({
  ids: z.array(z.string()),
  data: z.array(FindingListEnrichedDtoSchema),
});

export type FindingsListSelection = z.infer<typeof FindingsListSelectionSchema>;
export type UpdateFindingsByListSelection = z.infer<
  typeof UpdateFindingsByListSelectionSchema
>;
export type ResolveFindingsListSelectionResponse = z.infer<
  typeof ResolveFindingsListSelectionResponseSchema
>;
